/** Public ingest rate limits for creator sites (abuse resistance). */
export const CREATOR_SITE_PUBLIC_LIMITS = {
  /** Max lead submissions per site per rolling minute. */
  leadsPerSitePerMinute: 30,
  /** Max lead submissions for the same email on one site per day. */
  leadsPerSiteEmailPerDay: 3,
  /** Max analytics events per site per rolling minute. */
  analyticsPerSitePerMinute: 120,
  /** Window sizes (ms). */
  minuteWindowMs: 60_000,
  dayWindowMs: 24 * 60 * 60 * 1000,
  /** Suppress duplicate CRM activity for the same section within this window. */
  leadDedupeWindowMs: 24 * 60 * 60 * 1000,
} as const;

export type CreatorSiteRateLimitBucket = {
  timestamps: number[];
};

export function pruneRateLimitTimestamps(
  timestamps: number[],
  windowMs: number,
  now = Date.now(),
): number[] {
  const cutoff = now - windowMs;
  return timestamps.filter((value) => value >= cutoff);
}

export function assertCreatorSiteRateLimit(params: {
  timestamps: number[];
  windowMs: number;
  max: number;
  now?: number;
}): { ok: true; timestamps: number[] } | { ok: false; message: string } {
  const now = params.now ?? Date.now();
  const pruned = pruneRateLimitTimestamps(params.timestamps, params.windowMs, now);
  if (pruned.length >= params.max) {
    return { ok: false, message: 'Too many requests. Please try again later.' };
  }
  return { ok: true, timestamps: [...pruned, now] };
}
